/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { userInfoSync } from 'hub-http/userInfo';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import PaymentLinkSelect from 'payment-link-components/components/PaymentLinkSelect';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import * as PaymentsActions from 'ContentData/actions/Payments';
import * as paymentsSelectors from 'ContentData/selectors/payments';
import { SUCCEEDED, UNINITIALIZED } from 'ContentUtils/constants/RequestStatus';
import { PaymentsEligibilityStatus, PaymentsEligiblityUnderwritingStatus } from 'ContentData/types/redux/resources/payments';
import GetPaidWithPaymentLinksModal from 'payments-embed-points-lib/components/Modals/GetPaidWithPaymentLinksModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.payment.${key}`;
function mapStateToProps(state) {
  return {
    hasFetchedPaymentEligibility: paymentsSelectors.getHasFetchedPaymentEligibility(state),
    isLoading: paymentsSelectors.getIsLoading(state),
    paymentEligibility: paymentsSelectors.getPaymentEligibility(state),
    payments: paymentsSelectors.getPayments(state),
    paymentsFetchStatus: paymentsSelectors.getPaymentsFetchStatus(state)
  };
}
const mapDispatchToProps = {
  fetchPayments: PaymentsActions.fetchPayments,
  fetchPaymentEligibility: PaymentsActions.fetchPaymentEligibility
};
const GoToPaymentsButton = ({
  trackFieldAction
}) => {
  const handleClick = () => {
    if (trackFieldAction) {
      trackFieldAction('clicked-go-to-payments-button', {});
    }
  };
  return /*#__PURE__*/_jsx(UIButton, {
    href: Routes.payments(),
    external: true,
    use: "tertiary",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('goToPayments')
    })
  });
};
const SetUpPaymentsButton = ({
  trackFieldAction
}) => {
  const [showSetUpPaymentLinksModal, setShowSetUpPaymentLinksModal] = useState(false);
  const handleClick = () => {
    if (trackFieldAction) {
      trackFieldAction('clicked-set-up-payments-button', {});
    }
    setShowSetUpPaymentLinksModal(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showSetUpPaymentLinksModal && /*#__PURE__*/_jsx(GetPaidWithPaymentLinksModal, {
      onClose: () => setShowSetUpPaymentLinksModal(false),
      page: "CMS"
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: handleClick,
      size: "extra-small",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('preEnrollmentAlert.setUpPaymentsButton')
      })
    })]
  });
};
const CreatePaymentLinkButton = ({
  trackFieldAction
}) => {
  const handleClick = () => {
    if (trackFieldAction) {
      trackFieldAction('clicked-create-payment-link-button', {});
    }
  };
  return /*#__PURE__*/_jsx(UIButton, {
    external: true,
    href: Routes.paymentLinks(),
    onClick: handleClick,
    size: "extra-small",
    use: "tertiary-light",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('preEnrollmentAlert.createPaymentLinkButton')
    })
  });
};
const PaymentAlert = props => {
  const {
    titleTextMsg,
    children
  } = props;
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleTextMsg
    }),
    className: "p-y-4 style-sidebar-alert-title",
    "data-selenium": props['data-selenium'],
    children: /*#__PURE__*/_jsx(UIButtonWrapper, {
      children: children
    })
  });
};
const PaymentSelect = ({
  fetchPaymentEligibility,
  fetchPayments,
  hasFetchedPaymentEligibility,
  isLoading,
  error,
  onFieldChange,
  paymentEligibility,
  payments,
  paymentsFetchStatus,
  placeholder,
  required,
  readOnly,
  trackFieldAction,
  useOnDark,
  value
}) => {
  useEffect(() => {
    if (!hasFetchedPaymentEligibility) {
      fetchPaymentEligibility();
    }
  }, [hasFetchedPaymentEligibility, fetchPaymentEligibility]);
  useEffect(() => {
    if (hasFetchedPaymentEligibility && paymentEligibility.status === PaymentsEligibilityStatus.ACCOUNT_EXISTS && paymentEligibility.chargesEnabled && paymentsFetchStatus === UNINITIALIZED) {
      fetchPayments();
    }
  }, [fetchPayments, hasFetchedPaymentEligibility, paymentEligibility.chargesEnabled, paymentEligibility.status, paymentsFetchStatus]);
  const {
    openUpgradeModal
  } = useUpgradeModal('payments-cms-module');
  const paymentId = value && value.id;
  const hasNoPayments = paymentsFetchStatus === SUCCEEDED && !payments.length;
  function onChange(evt) {
    const newPaymentId = evt.target.value;
    const payment = payments.find(({
      id
    }) => id === Number(newPaymentId));
    if (payment && trackFieldAction) {
      trackFieldAction('payment-field-payment-selected', {
        total: payment.subtotals.firstPaymentTotal
      });
    }
    onFieldChange({
      id: newPaymentId
    });
  }
  const hasPaymentLinksWriteAccess = userInfoSync().user.scopes.includes('payment-links-write');
  const {
    status,
    underwritingStatus
  } = paymentEligibility;
  if (isLoading) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      className: "p-y-3"
    });
  }

  // a free account can NOT add a payment field, so this should not render
  // this is here in case this state ever occurs
  if (status === PaymentsEligibilityStatus.INELIGIBLE) {
    return /*#__PURE__*/_jsxs(PaymentAlert, {
      "data-selenium": "payment-field-ineligible-alert",
      titleTextMsg: i18nKey('emptyNoPaymentsAccessAlert.title'),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('emptyNoPaymentsAccessAlert.message')
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: openUpgradeModal,
        size: "extra-small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('upgrade')
        })
      })]
    });
  }
  if (status === PaymentsEligibilityStatus.ELIGIBLE || underwritingStatus === PaymentsEligiblityUnderwritingStatus.IN_KYC) {
    return /*#__PURE__*/_jsx(PaymentAlert, {
      "data-selenium": "payment-field-pre-enrollment",
      titleTextMsg: i18nKey('preEnrollmentAlert.title'),
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(SetUpPaymentsButton, {
          trackFieldAction: trackFieldAction
        }), /*#__PURE__*/_jsx(CreatePaymentLinkButton, {
          trackFieldAction: trackFieldAction
        })]
      })
    });
  }
  if (underwritingStatus === PaymentsEligiblityUnderwritingStatus.IN_UNDERWRITING) {
    const handleClick = () => {
      if (trackFieldAction) {
        trackFieldAction('clicked-go-to-payments-guide-button', {});
      }
    };
    return /*#__PURE__*/_jsx(PaymentAlert, {
      "data-selenium": "payment-field-pre-enrollment",
      titleTextMsg: i18nKey('awaitingApprovalAlert.title'),
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          external: true,
          href: Routes.paymentsGuide(),
          onClick: handleClick,
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('awaitingApprovalAlert.goToPaymentGuide')
          })
        }), /*#__PURE__*/_jsx(CreatePaymentLinkButton, {
          trackFieldAction: trackFieldAction
        })]
      })
    });
  }
  if (underwritingStatus === PaymentsEligiblityUnderwritingStatus.REJECTED) {
    return /*#__PURE__*/_jsx(PaymentAlert, {
      "data-selenium": "payment-field-not-collecting-alert",
      titleTextMsg: i18nKey('notCollectingPayments.title'),
      children: /*#__PURE__*/_jsx(UIButtonWrapper, {
        children: /*#__PURE__*/_jsx(GoToPaymentsButton, {
          trackFieldAction: trackFieldAction
        })
      })
    });
  }
  if (hasNoPayments && !hasPaymentLinksWriteAccess) {
    return /*#__PURE__*/_jsx(PaymentAlert, {
      "data-selenium": "payment-field-empty-no-read-alert",
      titleTextMsg: i18nKey('emptyNoWriteAccessAlert.title'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('emptyNoWriteAccessAlert.message')
      })
    });
  }
  if (hasNoPayments) {
    return /*#__PURE__*/_jsx(PaymentAlert, {
      "data-selenium": "payment-field-empty-alert",
      titleTextMsg: i18nKey('emptyAlert.title'),
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('emptyAlert.message')
        }), /*#__PURE__*/_jsx(UIButton, {
          external: true,
          href: Routes.paymentLinks(),
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('createPaymentLink')
          })
        })]
      })
    });
  }
  return /*#__PURE__*/_jsx(PaymentLinkSelect, {
    buttonUse: useOnDark ? 'form-on-dark' : 'form',
    clearable: !required,
    error: error,
    placeholder: placeholder,
    onChange: onChange,
    paymentLinks: payments
    // @ts-expect-error Type is supported but not explicitly typed
    ,
    readOnly: readOnly,
    value: paymentId
  });
};
export default connect(mapStateToProps, mapDispatchToProps)(PaymentSelect);